export default {
    SET_BILLBOARD_LABELS_SETTINGS: (state, data) => {
        state.billboardLabelsSettings = data
    },
    CLEAR_BILLBOARD_LABELS_SETTINGS: state => {
        state.billboardLabelsSettings = {
            workspace: null
        }
    },
    SET_STANDARD_LABELS_SETTINGS: (state, data) => {
        state.standardLabelsSettings = data
    },
    CLEAR_STANDARD_LABELS_SETTINGS: state => {
        state.standardLabelsSettings = {
            workspace: null
        }
    },
    SET_REVISORY_LABELS_SETTINGS: (state, data) => {
        state.revisoryLabelsSettings = data
    },
    CLEAR_REVISORY_LABELS_SETTINGS: state => {
        state.revisoryLabelsSettings = {
            workspace: null
        }
    }
}
